import { TIPTAP_FILE_TYPE } from "./../../ricos-content";
import { createRicosNodeExtension } from "./../../plugin-commons";
import { File as Component } from "./component";
const name = TIPTAP_FILE_TYPE;
const tiptapExtensions = [
  createRicosNodeExtension({
    groups: ["overlay", "draggable", "not-overtypable"],
    type: "react-node",
    name,
    reconfigure: (config, _extensions, _props, settings) => ({
      ...config,
      addOptions: () => settings
    }),
    Component,
    createExtensionConfig() {
      return {
        name: this.name,
        group: "block layoutCellContent collapsibleListItemBodyContent tableCellContent",
        selectable: true,
        draggable: true,
        addAttributes: () => ({
          containerData: null,
          src: null,
          name: null,
          type: null,
          size: null,
          pdfSettings: null,
          mimeType: null,
          path: null,
          sizeInKb: null,
          loading: {
            default: false
          },
          error: null
        }),
        addCommands() {
          return {};
        }
      };
    }
  })
];
export {
  tiptapExtensions
};
//# sourceMappingURL=tiptap.js.map
